import { useLogout } from '@refinedev/core'
import { Alert, Button } from 'antd'
import { useTranslation } from 'react-i18next'

import { getProxySession } from '../lib/auth-storage'
import { formatKstDateTime } from '../utils/formatKstDateTime'

/**
 * 슈퍼관리자 대행 접속 (#273) — always on top while an administrator works as this dealer, so it is
 * never mistaken for the dealer's own session. Ending it stops the token on the server at once.
 */
export function ProxySessionBanner() {
  const { t } = useTranslation()
  const { mutate: logout, isPending } = useLogout()
  const session = getProxySession()
  if (!session) return null

  return (
    <Alert
      type="warning"
      showIcon
      banner
      style={{ position: 'sticky', top: 0, zIndex: 10, marginBottom: 16 }}
      message={t('auth.proxy.banner', {
        admin: session.adminUsername,
        expiresAt: formatKstDateTime(session.expiresAt, 'YYYY-MM-DD HH:mm'),
      })}
      action={
        <Button size="small" danger loading={isPending} onClick={() => logout()}>
          {t('auth.proxy.end')}
        </Button>
      }
    />
  )
}
